import { PaginaCrud } from '../components/PaginaCrud'
import type { Proveedor } from '../types'

export default function Proveedores() {
  return (
    <PaginaCrud<Proveedor>
      titulo="Proveedores"
      recurso="proveedores"
      llave="id"
      columnas={[
        { campo: 'codigo', titulo: 'Codigo' },
        { campo: 'nombre', titulo: 'Nombre' },
        { campo: 'contacto', titulo: 'Contacto', render: (p) => p.contacto || '-' },
        { campo: 'telefono', titulo: 'Telefono', render: (p) => p.telefono || '-' },
        { campo: 'activo', titulo: 'Activo', render: (p) => (p.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'codigo', etiqueta: 'Codigo', tipo: 'texto', requerido: true },
        { nombre: 'nombre', etiqueta: 'Nombre', tipo: 'texto', requerido: true },
        { nombre: 'contacto', etiqueta: 'Contacto', tipo: 'texto' },
        { nombre: 'telefono', etiqueta: 'Telefono', tipo: 'texto' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activo: true }}
    />
  )
}
